import { render, staticRenderFns } from "./crowd-create.vue?vue&type=template&id=2d548470&scoped=true"
import script from "./crowd-create.vue?vue&type=script&lang=js"
export * from "./crowd-create.vue?vue&type=script&lang=js"
import style0 from "./crowd-create.vue?vue&type=style&index=0&id=2d548470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d548470",
  null
  
)

export default component.exports